import * as React from 'react';
import { observer } from 'mobx-react';
import { PageTitleLoaded } from '.';
import { useStores } from 'utility/hooks';

export const PageTitle = observer(() => {
  const { pageTitleStore, errorStore } = useStores();
  const { loading } = pageTitleStore;
  const { shouldRenderFailedRequestError } = errorStore;

  return loading || shouldRenderFailedRequestError ? null : <PageTitleLoaded />;
});
